export const defaultOption = { code: 'All', name: 'All', id: 'All' };
export const defaultOptionForAlertType = [
  {
    alertName: 'all',
    mongoAlertKey: '',
    alertType: 'All',
    alertDesc: 'All',
  },
];

export const dates = [
  { code: 'Yesterday', name: 'Yesterday', id: 'Yesterday' },
  { code: '7days', name: 'Last 7 days', id: '7days' },
  { code: 'custom', name: 'Custom', id: 'custom' },
];

export const panoramaDate = [
  { code: 'Today', name: 'Today', id: 'Today' },
  { code: 'Yesterday', name: 'Yesterday', id: 'Yesterday' },
  { code: '7days', name: 'Last 7 days', id: '7days' },
  { code: 'custom', name: 'Custom', id: 'custom' },
];

export const vehicleReportDates = [
  { code: 'Yesterday', name: 'Yesterday', id: 'Yesterday' },
  { code: '7days', name: 'Last 7 days', id: '7days' },
  { code: 'currentMonth', name: 'Current Month', id: 'currentMonth' },
  { code: 'lastMonth', name: 'Last Month', id: 'lastMonth' },
  { code: 'custom', name: 'Custom', id: 'custom' },
];

export const faultReportDates = [
  { code: 'Yesterday', name: 'Yesterday', id: 'Yesterday' },
  { code: '7days', name: 'Last 7 days', id: '7days' },
  { code: '30days', name: 'Last 30 days', id: '30days' },
  { code: 'custom', name: 'Custom', id: 'custom' },
];

export const routeTripDates = [
  { code: 'Today', name: 'Today', id: 'Today' },
  { code: 'Yesterday', name: 'Yesterday', id: 'Yesterday' },
  {
    code: 'Yesterday + Today',
    name: 'Yesterday + Today',
    id: 'Yesterday + Today',
  },
  { code: 'custom', name: 'Custom', id: 'custom' },
];

export const customer = {
  region: 'North',
  dealer: 'Delhi',
  customer: 'Tata',
};

export const dealer = {
  region: 'North',
  dealer: 'Delhi',
};

export const region = {
  region: 'North',
};

export const geoOptions = [
  { code: 'All', name: 'All', id: 'All' },
  { code: 'Route', name: 'Route', id: 'Route' },
  { code: 'Loading', name: 'Loading', id: 'Loading' },
  { code: 'UnLoading', name: 'UnLoading', id: 'UnLoading' },
  { code: 'Charging', name: 'Charging', id: 'Charging' },
  { code: 'Rest', name: 'Rest', id: 'Rest' },
  { code: 'General', name: 'General', id: 'General' },
];

export const chargingOptions = [
  { code: 'ALL', name: 'All', id: 'All' },
  { code: 'Manual', name: 'Manual', id: 'CT001' },
];

export const chargingOptionsTruck = [
  { code: 'ALL', name: 'All', id: 'All' },
  { code: 'Manual', name: 'Manual', id: 'CT001' },
  { code: 'Regenerative', name: 'Regenerative', id: 'CT002' },
];

export const zoneHourOptions = [
  { code: '4-8', name: '4 - 8 Hours', id: '4' },
  { code: '8-12', name: '8 - 12 Hours', id: '8' },
  { code: '12-24', name: '12 - 24 Hours', id: '12' },
  { code: '24', name: '> 1 Day', id: '24' },
  { code: '48', name: '> 2 Days', id: '48' },
  { code: '168', name: '> 7 Days', id: '168' },
];

export const severityOption = [
  {
    name: 'Critical',
    code: 'critical',
    id: 1,
  },
  {
    name: 'Non Critical',
    code: 'non-critical',
    id: 2,
  },
  {
    name: 'Regular',
    code: 'regular',
    id: 3,
  },
];

export const status = [
  {
    name: 'Active',
    code: 'active',
    id: 1,
  },
  {
    name: 'Inactive',
    code: 'inactive',
    id: 2,
  },
];

export const vehicleSelescted = {
  id: '',
  code: '',
  name: '',
};

export const scrollPagination = {
  pageNumber: 1,
  totalRecords: 0,
  pageSize: 50,
  bufferSize: 50,
  numberOfItemsFromEndBeforeFetchingMore: 50,
};

export const faultStatusOptions = [
  { code: '1', name: 'Active' },
  { code: '2', name: 'InActive' },
];

export const faultSeverityOptions = [
  {
    name: 'Low',
    code: 2,
  },
  {
    name: 'Medium',
    code: 3,
  },
  {
    name: 'High',
    code: 4,
  },
  {
    name: 'Critical',
    code: 5,
  },
];

export const networkOptions = [
  {
    name: '2G',
    code: '2G',
    id: 1,
  },
  {
    name: '4G',
    code: '4G',
    id: 2,
  },
];
